<template>
	<div>
			<TopAppBar
				:leftBtnMode="leftBtnMode"
				:rightBtnMode="rightBtnMode"
				:title="titleBrand"
				:leftBtnMethod="leftBtnMethod"
				:rightBtnMethod="rightBtnMethod"
        :hideCategory="false"
				staticMode="true"
			></TopAppBar>
		<div class="d-flex flex-column vh-100">
			<TopAppBarDrawer></TopAppBarDrawer>
					<main class="main-wrapper flex-grow-1">
						<div class="d-flex align-items-center ">
								<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
										{{this.$t("1720")}}
								</div>
						</div>
						<div class="divider"></div>
						<!-- subtabs -->
					<NoData v-if="isNoData"></NoData>
						<div class="container container--narrow mgt-30 mgb-50" v-else>
								<div class="mdc-card pdt-8 pdb-8">
									<div class="d-flex pdt-22 pdb-22 pdl-24 pdr-24 certificate-list cursor-pointer"
								v-for="(list, index) in listData"
								:key="index"
								@click="moveToDetail(list.id)" @keypress="moveToDetail(list.id)" tabindex="0">
										<div class="list-image-small40 mgr-20">
												<img src="../../images/my-certificate-icon.svg" alt="reward certificate icon">
										</div>
										<div class="flex-grow-1">
												<div class="t-body1 mgb-4  font-r l-spacing48 t-line-h-22">
														{{ list.name }}
												</div>
												<div class="t-body3  font-r pdr-24 l-spacing36 t-color-bodyGrayA  t-line-h-22" v-if="list.params.ISSUE_DATE">
														{{
              $t("1721", {
                str: $moment
                  .unix(list.params.ISSUE_DATE / 1000)
                  .format("L"),
              })
            }}
												</div>
										</div>
								</div>
								</div>
						<infinite-loading
        @infinite="fetchData"
        :identifier="infiniteId"
        spinner="spiral"
      >
        <div slot="no-more" class="mgt-16"></div>
        <div slot="no-results" class="mgt-16"></div>
      </infinite-loading>
						</div>

				</main>
		</div>
	</div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import rewardApi from "@/api/rewardApi.js";
import NoData from "../common/NoDataCertificateList.vue";
import InfiniteLoading from "vue-infinite-loading";
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";

export default {
	name: "CertificateList",
	components: {
		TopAppBar,
		NoData,
		InfiniteLoading,
		TopAppBarDrawer
	},
	filters: {
		convertDate(valu) {
			var date = new Date(valu);
			return date.toString("MMM dd");
		},
	},
	data() {
		return {
			status: "",
			isNoData: false,
			campaignData: null,
			listData: [],
			currentPage: 1,
			totalPages: 1,
			mine: "",
			myStatus: "",
			titleBrand: null,
			infiniteId: +new Date(),
		};
	},

	computed: {},

	watch: {
		$route(to, from) {
			this.initData();
			this.myStatus = this.$route.query.status;
		},
	},

	mixins: [topAppBarMixin],

	mounted() {
		this.titleBrand = localStorage.getItem('brandName');
		this.setTopAppBarHomeSearch();
	},

	methods: {
		initData() {
			this.listData = [];
			this.currentPage = 1;
			this.totalPages = 1;
			this.infiniteId += 1;
		},
		// 목록 데이터 로딩(get list data)
		fetchData($state) {
			let responseData = null;
			let params = this.setParams();
			//console.log("params", params);
			if (this.totalPages >= this.currentPage) {
				rewardApi
					.rewardCertificateList(params)
					.then((response) => {
						responseData = response.data.data;
						//console.log("responseData=>", responseData);
						// this.mine = responseData.mine;

						this.listData = this.listData.concat(responseData.content);
						//console.log("listData=>", this.listData);
						this.currentPage++;
						this.totalPages = responseData.totalPages;

						if (responseData.length) {
							$state.loaded();
						} else {
							$state.complete();
						}

						if (this.listData.length > 0) {
							this.isNoData = false;
						} else {
							this.isNoData = true;
						}
					})
					.catch((err) => {
						$state.error();
					});
			} else {
				$state.complete();
			}
		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				page: this.currentPage,
				size:10,
				sort: "id,desc",
			};
			return params;
		},

		moveToDetail(id) {
			this.$router.push("/certificatedetail/" + id);
		}
	},
};
</script>
